export default "__VITE_ASSET__BPOhqFvT__"